import View from './View';

export * from './constants';
export default View;
